import "./index.scss"
import code from "../../../../assets/recruit3.png"
import phone from "../../../../assets/recruit1.png"
import mail from "../../../../assets/recruit2.png"


function Recruit() {
  return (
    <div className="recruit-container">
      <div className="recruit-content">
        <div className="left">
          <div className="title">招募渠道合作伙伴</div>
          <div className="subtitle">RECRUIT CHANNEL</div>
          <div className="subtitle">PARTNERS</div>
        </div>
        <div className="center">
          <div className="phone">
            <img src={phone} className="img"></img>
            电话：189-0173-6838</div>
          <div className="mail"><img src={mail} className="img"></img>邮箱：RECHECK@BCNPL.COM</div>

        </div>
        <div className="right">
          <img className="code" src={code}></img>
        </div>
      </div>

    </div>
  )
}
export default Recruit